// Origem dos vínculos do De/Para: mapeamento salvo por uma pessoa × vínculo criado pela regra de
// pré-vinculação de Depreciação/Amortização (ação explícita do usuário no botão da tela).

export type OrigemVinculo = 'USUARIO' | 'REGRA';

export const ehVinculoDaRegra = (item: { origem?: string | null }): boolean => item.origem === 'REGRA';

export const contarVinculosDaRegra = (itens: { origem?: string | null }[]): number =>
  itens.filter(ehVinculoDaRegra).length;

export const ROTULO_REGRA = 'regra Depreciação/Amortização';
export const DICA_REGRA =
  'Vínculo criado pela regra de pré-vinculação de Depreciação/Amortização, não por um mapeamento manual. ' +
  'Editar o vínculo o transforma em mapeamento seu; "Desfazer pré-vinculações" remove só os da regra.';
